import { getCellText } from '@containers/Admin/containers/PendingDashboard/shared/SharedComponents';
import { isDesktop } from '@shared/constants/media-queries';
import { ROLES } from './consts';

const getRolesText = (roles) => {
  return roles?.map((role) => Object.entries(ROLES).find(([key, value]) => value === role)?.[0]).join(', ');
};

export const getTableColumn = (isTechAdmin = false) => {
  const standardColumnWidth = isTechAdmin ? '1fr' : 'calc(100% / 3)';
  const organizationColumnWidth = '1.3fr';

  return [
    {
      title: 'Name',
      getDisplay: ({ fullName }) => getCellText(fullName),
      sortable: true,
      sortField: 'fullName',
      width: standardColumnWidth,
    },
    {
      title: 'Email',
      getDisplay: ({ email }) => getCellText(email),
      sortable: false,
      sortField: 'email',
      width: standardColumnWidth,
    },
    {
      title: 'Roles',
      getDisplay: ({ roles }) => getCellText(getRolesText(roles)),
      sortable: false,
      sortField: 'roles',
      width: standardColumnWidth,
    },
    ...(isTechAdmin ? [{
      title: 'Business Unit',
      getDisplay: ({ businessUnitsInfo }) => getCellText(businessUnitsInfo?.map((businessUnit) => businessUnit?.name).filter(Boolean).join(', ')),
      sortable: false,
      sortField: 'businessUnitsInfo.name',
      width: organizationColumnWidth,
    }] : []),
  ];
};

export const staffListOffset = isDesktop() ? 15 : 9;
